'use client'

import { ContactFormContent } from 'components/pages/Contact/ContactPage'
import React from 'react'

const ContactPage = () => {
  return <ContactFormContent />
}

export default ContactPage
